(() => {
  if (window.bbqFooterReady) return;
  window.bbqFooterReady = true;
  const init = (root = document) => root.querySelectorAll('[data-bbq-footer]').forEach(footer => {
    if (footer.dataset.ready) return;
    footer.dataset.ready = 'true';
    const desktop = matchMedia('(min-width: 761px)');
    const menus = [...footer.querySelectorAll('[data-footer-menu]')];
    const update = () => menus.forEach(menu => {
      menu.open = desktop.matches;
      menu.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
    });
    menus.forEach(menu => menu.querySelector('summary').addEventListener('click', event => {
      if (desktop.matches) event.preventDefault();
    }));
    update();
    desktop.addEventListener('change', update);
    footer.querySelector('[data-footer-top]').addEventListener('click', event => {
      event.preventDefault();
      window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      const destination = document.querySelector('.hdr .brand') || document.querySelector('header a');
      if (destination) destination.focus({preventScroll:true});
    });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
